import { render, staticRenderFns } from "./section-trend-chart.vue?vue&type=template&id=07d62bc0&scoped=true"
import script from "./section-trend-chart.vue?vue&type=script&lang=js"
export * from "./section-trend-chart.vue?vue&type=script&lang=js"
import style0 from "./section-trend-chart.vue?vue&type=style&index=0&id=07d62bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d62bc0",
  null
  
)

export default component.exports